var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{ref:"colapsable",staticClass:"container__colapsable__main",class:[
		{
			horizontal: _setup.horizontal != undefined,
			vertical: _setup.horizontal == undefined,
			closed: _setup.toggle,
		},
	]},[_c('div',{staticClass:"container__colapsable__content",class:[
			{
				closed: _setup.toggle,
				horizontal: _setup.horizontal != undefined,
				vertical: _setup.horizontal == undefined,
			},
		],style:({ width: 100 - (_setup.recuo || 0) + '%' })},[(!_setup.toggle)?_vm._t("default"):_vm._e()],2),_c('div',{staticClass:"container__close",class:{
			closed: _setup.toggle,
			horizontal: _setup.horizontal != undefined,
			vertical: _setup.horizontal == undefined,
		},on:{"click":function($event){_setup.toggle = !_setup.toggle}}},[_vm._v(" "+_vm._s(_setup.horizontal != undefined ? 'Tabela de atributos' : '')+" "),_c(_setup.Icon,{class:[
				'colapse__icon',
				{
					closed: _setup.toggle,
					horizontal: _setup.horizontal != undefined,
					vertical: _setup.horizontal == undefined,
				},
			],attrs:{"icon":"material-symbols:arrow-forward-ios-rounded"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }